import { useState } from 'react';
import { getInitials } from 'util/initials';
import resolveMediaUrl from 'util/media';

/** Circular avatar — renders the profile photo when `src` is provided (falling
 *  back to initials if it's empty or fails to load), else initials derived from
 *  a name/email. */

// Default matches `.an-avatar` (mist/graphite monogram). `ink` is the
// special-emphasis variant (`.an-avatar--ink`) — reserved for highlighting a
// single row (e.g. "this is you"), not a general-purpose dark avatar.
export function Avatar({ name, src = '', size = 40, ink = false, className = '' }) {
  const [failed, setFailed] = useState(false);
  const resolved = resolveMediaUrl(src);
  const showImage = resolved && !failed;

  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full font-semibold ${
        ink ? 'bg-ink text-paper' : 'bg-mist text-graphite'
      } ${className}`}
      style={{ width: size, height: size, fontSize: size * 0.38 }}
      aria-hidden="true"
    >
      {showImage ? (
        <img
          src={resolved}
          alt=""
          className="h-full w-full object-cover"
          onError={() => setFailed(true)}
        />
      ) : (
        getInitials(name)
      )}
    </span>
  );
}

export default Avatar;
